<template>
  <div class="base">
    <main-header page_type="my_center" />
    <div class="container">
      <div class="info">
        <div class="personal">
          <a-row class="base-info" :gutter="8">
            <a-col :span="5" class="head-portrait">
              <div @click="goProfile()">
                <img :src="teacherInfo.avatar" alt="头像">
              </div>
              <div class="label">
                <span>教员</span>
              </div>
            </a-col>
            <a-col :span="15" class="name-login-area">
              <div class="name-area">
                <span class="name">{{ teacherInfo.nick_name }}</span>
                <span class="icon">
                  <a-icon type="safety-certificate" theme="filled" style="color: #d7b680;" />
                </span>
                <span class="apply" @click="goApply">申请</span>
              </div>
              <div class="last-login">
                <span>上次登录时间</span>
                <span style="margin-left: 10px">{{ teacherInfo.last_login_time | timeFormat }}</span>
              </div>
            </a-col>
            <a-col :span="4" class="setting-notice">
              <span class="setting" @click="goSetting">
                <a-icon type="setting" />
              </span>
              <span class="notice" @click="goNotice">
                <a-icon type="bell" />
              </span>
            </a-col>
          </a-row>
        </div>
        <div class="order-data">
          <div class="item" @click="goOrder('Cancelling')">
            <div>
              <a-badge :count="orderStatusGroup.Cancelling">
                <a-icon class="icon" type="folder-open" />
              </a-badge>
            </div>
            <div class="title">
              取消中
            </div>
          </div>
          <div class="item" @click="goOrder('Cancelled')">
            <div>
              <a-badge :count="orderStatusGroup.Cancelled">
                <a-icon class="icon" type="transaction" />
              </a-badge>
            </div>
            <div class="title">
              已取消
            </div>
          </div>
          <div class="item" @click="goOrder('Active')">
            <div>
              <a-badge :count="orderStatusGroup.Active">
                <a-icon class="icon" type="reload" />
              </a-badge>
            </div>
            <div class="title">
              进行中
            </div>
          </div>
          <div class="item" @click="goOrder('Complete')">
            <div>
              <a-badge :count="orderStatusGroup.Complete">
                <a-icon class="icon" type="file-done" />
              </a-badge>
            </div>
            <div class="title">
              已完成
            </div>
          </div>
          <div class="item" @click="goOrder('all')">
            <div>
              <a-badge :count="orderStatusGroup.all">
                <a-icon class="icon" type="ellipsis" />
              </a-badge>
            </div>
            <div class="title">
              全部
            </div>
          </div>
        </div>
      </div>
      <div class="other">
        <!-- 我的账户 -->
        <div class="my-account-area">
          <div class="one item">
            <span class="left">我的账户</span>
            <span class="right" @click="goAccountIncome">
              <a-icon type="right" />
            </span>
          </div>
          <div class="two-line item">
            <span class="left">总资产</span>
            <span class="right">待结算</span>
          </div>
          <div class="money-line item">
            <span class="left">￥{{ (parseFloat(teacherProfixInfo.total_revenue) -
                parseFloat(teacherProfixInfo.cash_withdrawn)).toFixed(2)
            }}</span>
            <span class="right">{{ teacherProfixInfo.be_settled }}</span>
          </div>
        </div>
        <!-- 服务包 -->
        <div class="pack-area">
          <div class="title-area">
            <span class="title left">我的服务包</span>
            <span class="right" @click="goPackList">
              <a-icon type="right" />
            </span>
          </div>
          <div class="list">
            <div v-for="(item, index) in servicePackList" :key="index" class="item">
              <div class="title" @click="goPackInfo(item.id)">
                <span>{{ item.title }}</span>
              </div>
              <div class="count">
                <span>已报名</span><span>{{ item.use_count > 0 ? item.use_count : 0 }}人</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 工单，帮助中心列表 -->
        <div class="function-list">
          <div class="item" @click="goCourseArrangement">
            <span class="icon">
              <a-icon type="exception" />
            </span>
            <span class="name">授课课程</span>
            <span class="right">
              <a-icon type="right" />
            </span>
          </div>
          <div class="item" @click="goTicket">
            <span class="icon">
              <a-icon type="exception" />
            </span>
            <span class="name">我的工单</span>
            <span class="right">
              <a-icon type="right" />
            </span>
          </div>
          <div class="item" @click="goHelps">
            <span class="icon">
              <a-icon type="question-circle" />
            </span>
            <span class="name">帮助中心</span>
            <span class="right">
              <a-icon type="right" />
            </span>
          </div>
          <div class="item" @click="goPromotion">
            <span class="icon">
              <a-icon type="security-scan" />
            </span>
            <span class="name">我要推广</span>
            <span class="right">
              <a-icon type="right" />
            </span>
          </div>
          <div class="item" @click="goArticle">
            <span class="icon">
              <a-icon type="profile" />
            </span>
            <span class="name">我的文章</span>
            <span class="right">
              <a-icon type="right" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 下一个 -->
  </div>
</template>
<script>
import { MainHeader } from '@/components'

export default {
  name: 'Moment',
  components: {
    MainHeader
  },
  data() {
    return {
      loading: true,
      orderStatusGroup: {},
      servicePackList: [],
      teacherInfo: {},
      teacherProfixInfo: {}
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$http({
        url: '/index/teacher/wapIndex',
        method: 'get'
      }).then(res => {
        console.log(res)
        this.loading = false
        if (res.status === 'success') {
          var data = res.data
          this.orderStatusGroup = data.order_status_group
          this.servicePackList = data.service_pack_list
          this.teacherInfo = data.teacher_info
          this.teacherProfixInfo = data.teacher_profix_info
        } else {
          this.$notification.error({
            message: '系统繁忙，请刷新重试',
            description: ''
          })
        }
      })
    },
    // 去设置
    goSetting() {
      this.$router.push({ name: 'TeacherSetting' })
    },
    // 通知
    goNotice() {

    },
    goOrder(orderStatus) {
      this.$router.push({ name: 'TeacherOrder', query: { status: orderStatus } })
    },
    // 教员账户
    goAccountIncome() {
      this.$router.push({ name: 'TeacherAccountIncome' })
    },
    // 去工单
    goTicket() {
      this.$router.push({ name: 'TeacherWorkOrder' })
    },
    // 去帮助中心
    goHelps() {
      this.$router.push({ name: 'Help' })
    },
    // 服务包列表
    goPackList() {
      this.$router.push({ name: 'TeacherServerPack' })
    },
    goPackInfo(id) {
      this.$router.push({ name: 'TeacherPackInfo', query: { id: id } })
    },
    // 去安全中心
    goPromotion() {
      this.$router.push({ name: 'TeacherPromotion' })
    },
    // 我的文章
    goArticle() {
      this.$router.push({ name: 'TeacherMyArticle' })
    },
    goApply() {
      this.$router.push({ name: 'TeacherMembersApply' })
    },
    goCourseArrangement() {
      this.$router.push({ name: 'TeacherCourseArrangement' })
    },
    goProfile() {
      this.$router.push({ name: 'TeacherProfile' })
    }
  }
}
</script>
<style lang="stylus">
  .base {
      min-width: 280px;
      max-width: 420px;
      margin: auto;
      background-color: #fff;
  }

  .container {
  }

  .info {
    background-color: #f6f6f6;
    padding: 15px;

    .personal {

      .base-info {
        margin-top: 10px;

        .head-portrait {
          text-align: center;

          img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            border: solid 1px #ffffff;
          }

          .label {
            span {
              display: inline-block;
              padding: 3px 7px 2px 7px;
              background-color: #fa750d;
              border-radius: 5px;
              opacity: 0.5;
              color: #fff;

              font-size: 10px;

              position: relative;
              top: -10px;
            }
          }
        }

        .name-login-area {

          .name-area {
            height: 32px;
            line-height: 32px;

            .name {
              font-family: PingFang-SC-Bold;
              font-size: 18px;
              line-height: 21px;
              letter-spacing: 0px;
              color: #333333;
              font-weight: bold;
            }

            .icon {
              margin-left: 10px;
            }

            .apply {
              color: #ff5c00;
              margin-left: 10px;
              cursor pointer
            }
          }

          .last-login {
            font-family: PingFang-SC-Regular;
            font-size: 12px;
            line-height: 32px;
            letter-spacing: 0px;
            color: #999999;
          }
        }

        .setting-notice {
          text-align: right;
          font-size: 18px;

          span:nth-child(1) {
            margin-right: 10px;
          }
        }
      }
    }

    .order-data {
      height: 80px;
      background-color: #ffffff;
      border-radius: 10px;
      width: 100%;
      overflow: hidden;
      padding: 15px;
      margin-top: 5px;

      .item {
        width: 20%;
        float: left;
        text-align: center;

        .icon {
          font-size: 18px;
        }

        .title {
          font-size: 12px;
        }
      }
    }
  }

  .other {
    padding: 0px 15px 15px 15px;
    background-color: #fff;

    .my-account-area {
      background-image: linear-gradient(90deg, #676f90 0%, #9ea9c1 100%),
      linear-gradient(#ffffff, #ffffff);
      background-blend-mode: normal, normal;
      border-radius: 10px;
      color: #fff;
      padding: 20px 16px;

      .item {
        overflow: hidden;

        .left {
          float: left;
        }

        .right {
          float: right;
        }
      }

      .one {
        .left {
          font-family: PingFang-SC-Bold;
          font-size: 16px;
          font-width: bold;
        }
      }

      .two-line {
        font-family: PingFang-SC-Bold;
        font-size: 14px;
        font-width: bold;

        margin-top: 10px;
      }

      .money-line {
        font-family: Bahnschrift-SemiBold;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 34px;
        letter-spacing: 0px;
        color: #fefefe;
      }
    }
  }

  .pack-area {
    padding: 20px 16px;
    box-shadow:0 0 10px 0 rgba(216,216,216,0.3);
    margin-top: 15px;

    .title-area {
      overflow: hidden;

      .left {
        float: left;
      }

      .right {
        float: right;
      }

      .title {
        font-family: PingFang-SC-Bold;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 21px;
        letter-spacing: 0px;
        color: #333333;
        font-weight: bold;
      }
    }

    .list {
      margin-top: 15px;

      .item {
        padding: 20px 15px;
        background-color: #f6f6f6;
        border-radius: 10px;
        margin-top: 10px;

        .title {
          span {
            font-family: PingFang-SC-Bold;
            font-size: 16px;
            line-height: 21px;
            letter-spacing: 0px;
            color: #333333;
            font-weight: bold;
          }
        }

        .count {

          span {
            font-family: PingFang-SC-Medium;
            font-size: 14px;
            line-height: 28px;
            color: #666666;
          }

          span:nth-child(2) {
            margin-left: 8px;
          }
        }
      }
    }
  }

  .function-list {
    padding: 20px 15px;

    .item {
      overflow: hidden;
      margin-bottom: 20px;

      .icon {
        float: left;
        color: #b9b9b9;
      }

      .name {
        float: left;
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        letter-spacing: 0px;
        color: #666666;

        margin-left: 15px;
      }

      .right {
        float: right;
        color: #999;
      }

    }
  }
</style>
